import { FC, SVGProps } from 'react';

const AISuggestionIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#7A7A7A',
  size = 20,
  ...props
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M17.9569 20.8244L17.8384 20.5039C17.3919 19.2955 16.4406 18.3427 15.2339 17.8955L14.9139 17.7769L15.2339 17.6583C16.4406 17.2112 17.3919 16.2584 17.8384 15.05L17.9569 14.7295L18.0753 15.05C18.5218 16.2584 19.4731 17.2112 20.6799 17.6583L20.9999 17.7769L20.6799 17.8955C19.4731 18.3427 18.5218 19.2955 18.0753 20.5039L17.9569 20.8244Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8796 3.84928C13.7646 2.64519 14.993 3.28918 15.9226 3.97243C16.8522 4.65567 17.8335 5.63586 16.9485 6.83994L7.39968 19.8068C7.13075 20.1727 6.72683 20.4161 6.27766 20.4828L4.01887 20.8182C3.71057 20.864 3.42302 20.6527 3.37469 20.3448L3.0206 18.0888C2.95019 17.6402 3.06186 17.1821 3.33079 16.8162L12.8796 3.84928Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.5 20.4292H11.51" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M4.01971 8.75465C4.16841 8.26537 4.55075 7.88245 5.03928 7.73353C4.55075 7.5846 4.16841 7.20168 4.01971 6.7124C3.87101 7.20168 3.48867 7.5846 3.00012 7.73353C3.48867 7.88245 3.87101 8.26537 4.01971 8.75465Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AISuggestionIcon;
